/*-----------------------------------------------------------------
- Contact info
-----------------------------------------------------------------*/
export default {
    branch_name      : 'نام شعبه',
    branch_admin_name: 'مدیریت',
    address          : 'آدرس',
    tel              : 'تلفن',
    fax              : 'فکس',
    email            : 'ایمیل',
    separator        : ':',
};
